/* eslint-disable */
import {
  cardTitle,
  grayColor,
  whiteColor,
  warningColor,
  dangerColor,
  successColor,
} from "assets/jss/material-dashboard-pro-react.js";
import customSelectStyle from "assets/jss/material-dashboard-pro-react/customSelectStyle.js";
import customInputStyle from "assets/jss/material-dashboard-pro-react/components/customInputStyle";
//import { opacity } from "html2canvas/dist/types/css/property-descriptors/opacity";

const userManagmentStyle = (theme, clientColor) => ({
  ...customSelectStyle(theme, clientColor),
  ...customInputStyle(clientColor),

  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px",
  },
  attention: {
    backgroundColor: warningColor[0] + " !important",
    animation: "$attention 3s ease infinite",
  },
  "@keyframes attention": {
    "10%": {
      transform: "scale(1.1)",
    },
    "13.33%,20%": {
      transform: "rotate(-10deg) scale(1.1)",
    },
    "16.67%": {
      transform: "rotate(10deg) scale(1.1)",
    },
    "23.33%": {
      transform: "rotate(0deg) scale(1.1)",
    },
    "33%": {
      transform: "scale(1)",
    },
  },
  actionDisabled: {
    opacity: "0.5 !important",
    pointerEvents: "none",
  },
  cardButton: {
    padding: "0 !important",
    margin: "15px 0 0 10px !important",
    height: "22px !important",
    width: "30px !important",
    minWidth: "0 !important",
    position: "relative",
    transition: "all 0.2s",
    backgroundColor: clientColor + " !important",
  },
  cardButtonNoMargin: {
    padding: "0 !important",
    //margin: "15px 15px 0 10px !important",
    height: "24px !important",
    width: "32px !important",
    minWidth: "0 !important",
    position: "relative",
    transition: "all 0.2s",
    backgroundColor: clientColor + " !important",
    "&.MuiButton-root": {
      cursor: "pointer", // Aplica o cursor especificamente ao botão Material-UI
    },
  },
  cardButtonSecondary: {
    padding: "0 !important",
    margin: "15px 0 0 10px !important",
    height: "22px !important",
    width: "30px !important",
    minWidth: "0 !important",
    position: "relative",
    transition: "all 0.2s",
    backgroundColor: "#999" + " !important",
  },
  cardButtonIcon: {
    margin: "0 !important",
    position: "absolute !important",
    top: "50% !important",
    left: "50% !important",
    transform: "translate(-50%, -50%)",
    width: "18px !important",
    height: "18px !important",
    color: "#FFFFFF",
  },
  cardButtonAtt: {
    padding: "0 !important",
    margin: "15px 0 0 10px !important",
    height: "30px !important",
    width: "38px !important",
    minWidth: "0 !important",
    position: "relative",
    transition: "all 0.2s",
    backgroundColor: clientColor + " !important",
  },
  cardButtonIconAtt: {
    margin: "0 !important",
    position: "absolute !important",
    top: "50% !important",
    left: "50% !important",
    transform: "translate(-50%, -50%)",
    width: "25px !important",
    height: "25px !important",
    color: "#FFFFFF",
  },

  actionDisabled: {
    opacity: "0.5 !important",
    pointerEvents: "none",
  },

  toolTipRole: {
    fontSize: "1.1em",
    fontWeight: "bold",
  },
  toolTipDescription: {
    paddingLeft: "1em",
    display: "block",
    fontWeight: "100 !important",
  },

  "@keyframes loadingAnimation": {
    "0%": { backgroundColor: grayColor[4] },
    "25%": { backgroundColor: grayColor[3] },
    "50%": { backgroundColor: grayColor[4] },
    "75%": { backgroundColor: grayColor[3] },
    "100%": { backgroundColor: grayColor[4] },
  },
  loadingAnimation: {
    animation: "$loadingAnimation 4.0s ease-in-out infinite",
  },

  selectFormControlOverride: {
    margin: "3px 0 5px 0 !important",
    paddingTop: "1px",
    paddingBottom: "1px",
    "& > div": {
      "&:before": {
        borderBottomWidth: "0.8px !important",
      },
    },
  },

  tableHeadCell: {
    fontWeight: "300",
    fontSize: "15px",
  },
  tableBodyCell: {
    fontSize: "12px !important",
    fontWeight: "300",
    borderBottom: `1px solid rgba(0, 0, 0, 0.05)`,
  },
  compactTable: {
    "& .MuiTableCell-root": {
      padding: "1px 1px 2px 10px !important",
      lineHeight: "0.1 !important",
      height: "5px !important",
      whiteSpace   : 'normal',
      wordBreak    : 'break-word',
      //overflow: "hidden",
    },
    "& .MuiTableRow-root": {
      height: "40px",
    },
  },
  tableSpinner: {
    height: "100%",
    paddingTop: "4px",
    "& > svg": {
      width: "40px !important",
    },
  },

  labelRootCustom: {
    fontFamily: '"Roboto"',
    color: "black" + " !important",
    textTransform: "uppercase",
    fontSize: ".75rem",
    fontWeight: "400",
    lineHeight: "1.42857",
    letterSpacing: "unset",
  },
  labelInsideSelectCustom: {
    fontFamily: '"Roboto"',
    color: "black" + " !important",
    fontSize: ".75rem",
    fontWeight: "400",
    lineHeight: "1.42857",
    letterSpacing: "unset",
    textTransform: "uppercase",
  },

  labelLeaders: {
    marginTop: "8px",
    minHeight: "24px",
    fontSize: "14px",
    color: "#333",
    fontWeight: 300,
  },

  labelMultiSelect: {
    fontSize: "16px",
    color: grayColor[1],
    fontWeight: 400,
  },

  iconButtonCustom: {
    cursor: "pointer",
    "&:hover": {
      color: clientColor,
    },
  },

  multiSelectContainer: {
    display: "flex",
    flexDirection: "column",
    boxSizing: "border-box",
    padding: "5px 7px 7px 7px",
  },

  newBlock: {
    //border: "1px solid #ccc", // Adiciona a borda ao redor da seção
    //borderRadius: "3px", // Arredonda os cantos da borda
    padding: "20px", // Adiciona espaçamento interno
    marginTop: "10px",
    marginBottom: "10px", // Espaço abaixo da seção
    //backgroundColor: grayColor[13],
  },

  tabsRoot: {
    backgroundColor: grayColor[8],
    //boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
  },
  tabRoot: {
    fontSize: "1rem",
    fontWeight: 400,
    color: "black",
    textTransform: "uppercase",
    "&:hover": {
      color: clientColor,
      opacity: 1,
    },
    "&.Mui-selected": {
      color: "black",
      fontWeight: 500,
      borderBottom: `2px solid ${clientColor}`,
    },
    "&:focus": {
      color: "black",
    },
  },
  indicator: {
    backgroundColor: clientColor,
    height: "1.5px",
  },

  textFieldRoot: {
    "& .MuiInput-underline:before": {
      borderBottom: "1px solid #ccc", // Cor padrão da borda inferior
    },
    "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
      borderBottom: `2px solid ${clientColor}`, // Cor ao passar o mouse
    },
    "& .MuiInput-underline:after": {
      borderBottom: `2px solid ${clientColor}`, // Cor quando selecionado
    },
  },
  inputText: {
    color: "#666", // Cor do texto padrão
    "&:focus": {
      color: "#666", // Cor do texto quando selecionado
    },
  },
  labelText: {
    color: "#666", // Cor padrão do label
    "&.Mui-focused": {
      color: "#666", // Cor do label quando focado
    },
  },

  collapsibleSection: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(2),
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
  },

  buttonSuccess: {
    backgroundColor: "green !important",
    color: "#fff",
    animation: "$attention 3s ease",
  },

  buttonError: {
    backgroundColor: "#f44336 !important", // Material-UI red
    color: "#fff",
    animation: "$attention 3s ease",
  },

  switchBase: {
    "&.Mui-checked": {
      color: clientColor, // Cor do "thumb"
    },
    "&.Mui-checked + .MuiSwitch-track": {
      backgroundColor: clientColor, // Cor do "track" quando ativo
    },
    // "&:hover, &:focus, &:focus-visible": {
    //   backgroundColor: "transperent !important", // Remove cor rosada ao hover/focus
    // },
    "&.Mui-checked:hover": {
      backgroundColor: "transparent !important", // Remove hover quando ativado
    },
    "&:focus, &:focus-visible": {
      outline: "none", // Remove o efeito de foco
      backgroundColor: "transparent !important",
    },
    "&::after": {
      backgroundColor: "transparent !important", // Remove pseudo-elementos
    },
  },
  track: {
    backgroundColor: grayColor[2], // Cor do track desativado (opcional)
  },

  checkboxRoot: {
    color: grayColor[2], // Cor padrão (não selecionado)
    "&.Mui-checked": {
      color: clientColor, // Cor quando selecionado
    },
    "&:hover": {
      backgroundColor: "transparent !important", // Remove hover
    },
    "&.Mui-checked:hover": {
      backgroundColor: "transparent !important", // Remove hover quando ativado
    },
    "&:focus, &:focus-visible": {
      outline: "none", // Remove o efeito de foco
      backgroundColor: "transparent !important",
    },
    "&::after": {
      backgroundColor: "transparent !important", // Remove pseudo-elementos
    },
  },

  searchIcon: {
    color: grayColor[1],
    fontSize: "1.3rem",
  },

  customTooltip: {
    backgroundColor: grayColor[1], // Cor de fundo do Tooltip
    //color: "#fff", // Cor do texto do Tooltip
    fontSize: "13px", // Tamanho da fonte
    borderRadius: "4px", // Bordas arredondadas
    padding: "5px", // Espaçamento interno
  },
  customArrow: {
    color: grayColor[1], // Cor da seta
  },

  iconDisabled: {
    opacity: "0.5 !important",
    pointerEvents: "none",
  },

  legendFiles: {
    marginRight: "5px", // Espaçamento entre legenda e botão
    textAlign: "right", // Justifica à esquerda
    width: "300px", // Largura fixa para alinhamento consistente
    marginTop: "12px",
  },

  legendButtonsRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center", // Centraliza o conjunto de botões e legendas
    gap: "10px", // Espaçamento entre os itens
    marginRight: "90px",
  },
  legendButtonsColumn: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center", // Centraliza o conjunto de botões e legendas
    gap: "10px", // Espaçamento entre os itens
    marginRight: "90px",
  },
  uploadFilesTitle: {
    marginBottom: "10px",
    fontWeight: 400,
    textAlign: "center",
    textTransform: "none",
    marginTop: "0px",
  },

  centerFilesSection: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
  },

  inputBox: {
    display: "inline-block",
    margin: theme.spacing(1),
    padding: theme.spacing(2),
    backgroundColor: "#f5f5f5",
    borderRadius: "6px",
    width: "270px",
    height: "240px",
    position: "relative",
    textAlign: "center",
  },
  sectionTitle: {
    position: "absolute",
    top: "8px",
    left: "8px",
    right: "8px",
    fontSize: "14px",
    fontWeight: "bold",
  },

  fileStatus: {
    position: "absolute",
    top: "87%",
    width: "26px",
    height: "26px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transform: "translate(-50%,-50%)",
    backgroundColor: grayColor[3],
    color: whiteColor,
    borderRadius: "6px",
    "&.success": {
      backgroundColor: successColor[3],
    },
    "&.warning": {
      backgroundColor: warningColor[3],
    },
    "&.error": {
      backgroundColor: dangerColor[3],
    },
    "&.running": {
      backgroundColor: grayColor[1],
      backgroundImage:
        "linear-gradient(-45deg, rgba(255, 255, 255, 0.25) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.25) 50%, rgba(255, 255, 255, 0.25) 75%, transparent 75%, transparent)",
      backgroundSize: "15px 15px",
      animation: "$move 2s linear infinite",
      color: whiteColor,
    },
  },
});

export default userManagmentStyle;
